<template>
  <div class="ru-social">
    <div class="devider"><span>{{ $t("AUTH_OR") }}</span></div>
    <p v-if="locked" class="ru-social__hint">{{ $t("AUTH_CONSENT_REQUIRED_SOCIAL") }}</p>
    <a
      v-for="p in providers"
      :key="p.id"
      :href="locked ? null : startUrl(p.id)"
      class="ru-social__btn"
      :class="{ 'is-disabled': locked }"
      :aria-disabled="locked ? 'true' : null"
    >
      <span class="ru-social__icon" v-html="p.icon"></span>
      {{ $t("AUTH_CONTINUE_WITH", { name: p.name }) }}
    </a>
  </div>
</template>

<script>
// Вход через Яндекс ID и VK ID (VK ID даёт и Mail.ru). Кнопка ведёт на
// ru-auth: /api/oauth/<provider>/start — дальше сервер сам ходит к провайдеру
// и возвращает в /auth/oauth (Oauth-callback.vue).
// Со страницы регистрации уходит consent=1 (галочка согласия отмечена) — только
// так ru-auth создаёт нового пользователя; со страницы входа — только вход.
const ICONS = {
  yandex:
    '<svg viewBox="0 0 24 24" width="18" height="18"><circle cx="12" cy="12" r="12" fill="#FC3F1D"/><path d="M13.4 6.2h-1.1c-2 0-3.1 1-3.1 2.6 0 1.8.8 2.6 2.4 3.7l1.3.9-3.8 5.6H6.2l3.4-5c-2-1.4-3.1-2.7-3.1-5 0-2.9 2-4.9 5.8-4.9h3.8V18h-2.7V6.2z" fill="#fff"/></svg>',
  vk:
    '<svg viewBox="0 0 24 24" width="18" height="18"><rect width="24" height="24" rx="6" fill="#0077FF"/><path d="M12.8 17c-5 0-7.9-3.4-8-9.1h2.5c.1 4.2 1.9 5.9 3.4 6.3V7.9h2.4v3.6c1.4-.2 2.9-1.8 3.4-3.6h2.3c-.4 2.2-2 3.8-3.2 4.5 1.2.6 3 2 3.7 4.6h-2.6c-.5-1.7-1.9-3.1-3.6-3.3V17h-.3z" fill="#fff"/></svg>',
  mail_ru:
    '<svg viewBox="0 0 24 24" width="18" height="18"><circle cx="12" cy="12" r="12" fill="#005FF9"/><path d="M14.6 12a2.6 2.6 0 1 1-5.2 0 2.6 2.6 0 0 1 5.2 0zm-2.6-6.6a6.6 6.6 0 1 0 3.5 12.2l-.7-1.2A5.2 5.2 0 1 1 17.2 12c0 1.1-.4 1.9-1.1 1.9s-1.1-.8-1.1-1.9V8.5h-1.3v.8a3.9 3.9 0 1 0 .3 5.3c.4.8 1.2 1.2 2.1 1.2 1.6 0 2.5-1.4 2.5-3.8a6.6 6.6 0 0 0-6.6-6.6z" fill="#FF9E00"/></svg>',
};

export default {
  name: "SocialLogin",
  props: {
    // login — только вход; signup — вход или регистрация (нужна галочка согласия)
    mode: { type: String, default: "login" },
    consent: { type: Boolean, default: false },
  },
  data() {
    return {
      providers: [
        { id: "yandex", name: "Яндекс ID", icon: ICONS.yandex },
        { id: "vk", name: "VK ID", icon: ICONS.vk },
        { id: "mail_ru", name: "Mail.ru", icon: ICONS.mail_ru },
      ],
    };
  },
  computed: {
    locked() {
      return this.mode === "signup" && !this.consent;
    },
  },
  methods: {
    startUrl(provider) {
      const params = new URLSearchParams({
        consent: this.mode === "signup" && this.consent ? "1" : "0",
        lang: (this.$i18n.locale || "ru").toUpperCase(),
      });
      return `${process.env.VUE_APP_API}oauth/${provider}/start?${params}`;
    },
  },
};
</script>

<style scoped>
.ru-social__hint {
  margin: 0 auto 10px;
  max-width: 320px;
  font-size: 12px;
  line-height: 16px;
  color: #8a8a8a;
  text-align: center;
}
.ru-social__btn {
  position: relative;
  margin: 0 auto 10px;
  border-radius: 8px;
  box-shadow: inset 0 0 0 0.5px #2196f3;
  max-width: 100%;
  width: 320px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 9px 32px;
  font-size: 13px;
  letter-spacing: 0.25px;
  line-height: 14px;
  color: inherit;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s ease;
}
.ru-social__btn:hover {
  background: #ecf6ff;
}
.ru-social__btn.is-disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.ru-social__btn.is-disabled:hover {
  background: none;
}
.ru-social__icon {
  position: absolute;
  left: 12px;
  display: flex;
}
</style>
